<template>
    <div>
        <slot :error="error" />
        <div class="invalid-feedback" :class="errorClasses">
            {{ error }}
        </div>
    </div>
</template>

<script>
    export default {
        inject: {
            form: {
                default: null,
            }
        },
        props : {
            name: {
                type: String,
                required: true,
            },
            errorClass: String,
        },
        data() {
            return {
                error: null
            }
        },
        computed: {
            errorClasses() {
                return [
                    { 'd-block': !!this.error },
                    this.errorClass,
                ];
            }
        },
        methods: {
            input() {
                return this.$el.querySelector(`[name="${this.name}"]:not([type=hidden])`)
                    || this.$el.querySelector(`.form-control, input:not([type=hidden]), select, textarea`);
            },
            // used by injected form
            setError(error) {
                if(error) {
                    this.input()?.classList.add('is-invalid');
                    this.error = error;
                }
            },
            // used by injected form
            clear() {
                this.error = null;
                this.input()?.classList.remove('is-invalid');
            }
        },
        mounted() {
            this.form?.registerField(this);
        },
        destroyed() {
            this.form?.unregisterField(this);
        }
    }
</script>
